import { PurchasesTracesService } from 'src/app/services/purchases-traces.service';
import { AppPaths } from 'src/app/constants/app-paths';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-purchases-trace-menu',
  templateUrl: './purchases-trace-menu.component.html',
})
export class PurchasesTraceMenuComponent {
  private _purchasesTracesService = inject(PurchasesTracesService);
  protected PURCHASES_TRACES = AppPaths.PURCHASES_TRACES;

  protected openPurchaseTraceDialog(): void {
    this._purchasesTracesService.openPurchaseTraceDialog();
  }
}
